import { IDLE, SYNC_UPDATE } from './SyncConstants';
export default function queueUserConfigForSync(draft){

  draft.syncStatus.userConfig = { 
    syncKey:SYNC_UPDATE,
    status:IDLE
  }

}
